export default __webpack_public_path__ + "static/media/founder-card-image.bde033ae.png";